import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./home.css";
import axios from "axios";
import {
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaLinkedin,
} from "react-icons/fa";
import { Button, Carousel } from "react-bootstrap";
import { Card, Container, Row, Col, Image } from "react-bootstrap";
import banner1 from "../../Images/Banner1.jpg";
import banner2 from "../../Images/Banner2.jpg";
import banner3 from "../../Images/Banner3.jpg";
import banner4 from "../../Images/Banner4.jpg";
import banner5 from "../../Images/Banner5.jpeg";
import banner6 from "../../Images/Banner6.jpg";
import susan from "../../Images/susanMathew.jpg";
import building from "../../Images/Building.jpg";

// import { Card as CustomCard, CardContent } from '@/components/card';

function Home() {
  const [managementTeam, setManagementTeam] = useState([]);
  const [expandedCards, setExpandedCards] = useState({});

  const [galleryMedia, setGalleryMedia] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleViewGallery = () => {
    navigate("/gallery");
  };

  // const [galleryImages, setGalleryImages] = useState([]);

  useEffect(() => {
    fetch(
      "https://api.deepticentre.com/deeptischool/list/gallery-image",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.result && data.list) {
          const media = data.list
            .filter((item) => item.g_status === "active")
            .map((item) => {
              const fileUrl = `https://api.deepticentre.com${item.g_file}`;
              const extension = fileUrl.split(".").pop().toLowerCase();

              return {
                type: ["mp4", "mov", "webm"].includes(extension)
                  ? "video"
                  : "image",
                src: fileUrl,
              };
            });
          setGalleryMedia(media);
        }
      })
      .catch((err) => {
        console.error("Error fetching gallery media:", err);
      });
  }, []);

  useEffect(() => {
    axios
      .post("https://api.deepticentre.com/deeptischool/list/management")
      .then((response) => {
        setManagementTeam(response.data.list);
      })
      .catch((error) => {
        console.error(
          "There was an error fetching the management data!",
          error
        );
      });
  }, []);
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const conditions = [
    {
      title: "Autism Spectrum Disorder",
      text: "Autism Spectrum Disorder (ASD) is a neurodevelopmental condition characterized by challenges in social communication and interaction, alongside restricted and repetitive patterns of behaviour, interests, or activities. This spectrum disorder affects individuals uniquely, with varying degrees of impact on their ability to navigate social cues, form relationships, and engage in reciprocal conversations. Individuals with ASD may also exhibit sensory sensitivities and strict adherence to routines and difficulty with change. While the exact causes are complex and likely involve genetic and environmental factors, early intervention through therapies and support can significantly improve outcomes and help individuals with ASD develop skills and manage challenges throughout their lives.",
      image:
        "https://media.kidsacademy.mobi/files/Blog%20Pictures%20/importance_interactive_learning/shutterstock_1105793417_1.jpg",
      altText:
        "Teacher working with a child on interactive learning activities",
    },
    {
      title: "Cerebral Palsy",
      text: "Cerebral Palsy (CP) is the most prevalent motor disability in childhood, encompassing a group of disorders that impair movement, balance, and posture due to abnormal brain development or damage occurring before, during, or shortly after birth. While congenital CP, resulting from pre-natal or birth-related brain injury, accounts for the majority of cases, the exact cause often remains unknown. Symptoms vary widely, ranging from muscle stiffness and poor co-ordination to delays in motor skills and, in some instances, intellectual disabilities or sensory impairments. Although there is no cure for CP, a range of treatments including therapies, medications, and sometimes surgery can significantly improve an individual's quality of life by addressing specific needs and enhancing functional abilities.",
      image:
        "https://media.gettyimages.com/id/1306728106/photo/young-patient-doing-physiotherapy-at-a-clinic-with-help-of-a-therapist.jpg?s=612x612&w=gi&k=20&c=Xu73AyCYA2-N8sLz0E7ok8h2RNQz57Aj6BulQUUHhxs=",
      altText: "Physical therapy session with adaptive equipment",
    },
    {
      title: "Downs Syndrome",
      text: "Downs syndrome is a genetic condition characterized by an extra copy of chromosome 21, which alters typical physical and brain development, leading to developmental delays and distinctive physical features present from birth, such as a flattened face, almond-shaped eyes, and a protruding tongue. Individuals with Downs Syndrome may also experience other health issues like congenital heart defects and hearing loss. However, with early intervention therapies, special education, regular medical care, and strong community and family support, people with Down syndrome can lead meaningful and active lives, achieving personal growth, forming relationships, and contributing to their communities, showcasing a wide spectrum of abilities and strengths.",
      image:
        "https://static.wixstatic.com/media/bd0585a054cb4056b001429bb73d36b7.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/bd0585a054cb4056b001429bb73d36b7.jpg",
      altText: "Students engaging in group learning activities",
    },
    {
      title: "ADHD",
      text: "ADHD (Attention Deficit Hyperactivity Disorder) is a common neurobehavioral developmental disorder affecting individuals of all ages, characterized by difficulties in focusing, controlling impulses, and managing activity levels. Individuals with ADHD may exhibit symptoms such as inattention, hyperactivity, and impulsivity, which can persist throughout life and affect various aspects of daily functioning. Diagnosis typically involves a comprehensive evaluation, and treatment often includes a combination of behavioral therapy, occupational therapy, creative play, medication, and lifestyle adjustments.",
      image:
        "https://www.waterford.org/wp-content/uploads/2019/12/iStock-642634764-scaled.jpg",
      altText: "Student working on an engaging hands-on project",
    },
    {
      title: "Intellectual Disability",
      text: "Intellectual disability (ID) is a developmental condition characterized by significantly below-average intellectual functioning (typically an IQ below 70), along with limitations in adaptive skills needed for daily life, such as communication, social interaction, and self-care. These challenges must begin before the age of 18. Causes can include genetic conditions (like Downs Syndrome), pre-natal issues (such as infections or substance exposure), complications during birth, or post-natal factors like brain injury or illness. ID is categorized by severity—mild, moderate, severe, or profound—based on the level of support required. Diagnosis involves cognitive and adaptive behavior assessments, as well as developmental history and caregiver input. Support through special education, therapy (speech, occupational, behavioral), life skills training, and vocational programs can greatly enhance quality of life and independence.",
      image:
        "https://www.thoughtco.com/thmb/kINIPLN5a8t6JrX-lOCQFlICNVU=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/mother-teaching-her-children-535051414-5af4a2b9ff1b78002075b6cc.jpg",
      altText: "Teacher helping student with learning materials",
    },

    {
      title: "Learning Disability",
      text: "Learning disabilities are neurological conditions that affect how people acquire, process, store, and use information, and are distinct from intelligence levels. These disabilities, stemming from differences in brain structure and function, impact specific learning areas such as reading (dyslexia), writing (dysgraphia), and math (dyscalculia), as well as auditory processing and nonverbal skills. Early identification and intervention are crucial for individuals to develop effective strategies to manage these challenges, often supported by individualized education programs and accommodations like extended test time and assistive technology.",
      image:
        "https://ldnetwork.org/fixefybo/2023/10/Man-with-learning-disability-sitting-with-support-worker-using-laptop-for-lesson-at-home.jpg",
      altText: "One-on-one tutoring session",
    },
    {
      title: "Multiple Disability",
      text: "Multiple Disability  refers to the presence of two or more disabilities—such as physical, intellectual, sensory, or emotional—that together create complex challenges in areas like learning, communication, and daily living. These individuals often require tailored education plans, multidisciplinary support, and therapies focused on communication, mobility, and life skills. The goal is to enhance independence, inclusion, and overall quality of life.",
      image:
        "https://www.tappytoesnursery.com/wp-content/uploads/2024/02/how-to-improve-students-pronunciation.jpg",
      altText:
        "Speech therapist working with a child on pronunciation exercises",
    },
  ];
  const testimonials = [
    {
      text: "My son has been attending therapy sessions at Deepti School of Special Education for 1 year. I am grateful to be a part of Deepti School for my son's therapy. My son receives support from Deepti School as he has speech delay as well as some sensory issues. The therapists at Deepti School did a thorough assessment of my son and set goals accordingly. I was able to see significant changes in him within a short span of time. The therapists come up with ideas that are perfect for my son, and they treat him so well. I highly recommend Deepti School to other parents who have kids with similar needs.",
      author: "Sobha Anup",
    },
    {
      text: "Deepti School of Special Education has been a blessing for my child. The therapists are highly professional and provide personalized attention. Within months, I saw remarkable improvement in my child's communication skills.",
      author: "Rajesh Kumar",
    },
  ];

  const chunkArray = (arr, size) => {
    return arr.reduce(
      (acc, _, i) => (
        i % size ? acc[acc.length - 1].push(arr[i]) : acc.push([arr[i]]), acc
      ),
      []
    );
  };

  const groupedServices = chunkArray(conditions, 4);

  // const [expandedCards, setExpandedCards] = useState({});

  const toggleExpand = (index) => {
    setExpandedCards((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <>
      <div className="home-page-design">
        {/* Hero Section with Animated Carousel */}
        <motion.div
          initial={{ x: "-100vw", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ type: "tween", duration: 2 }}
        >
          <div className="hero-section position-relative">
            <Carousel
              fade
              activeIndex={index}
              onSelect={handleSelect}
              controls={false}
              indicators={false}
            >
              {[
                {
                  img: banner1,
                  title: "WELCOME TO DEEPTI SPECIAL SCHOOL",
                  // text: "A Vibrant, Caring & Harmonious Learning Community",
                },
                {
                  img: banner2,
                  title: "A Place Where Every Child Matters",
                  // text: "A Place Where Every Child Matters",
                },
                {
                  img: banner3,
                  title: "Celebrating harmony by embracing diversity",
                  // text: "Join Us in Making a Difference",
                },
                {
                  img: banner4,
                  title: "In every game,song,or step you inspire",
                  // text: "Join Us in Making a Difference",
                },
                {
                  img: banner5,
                  title: "Learning beyond walls, together we travel and thrive",
                  // text: "Join Us in Making a Difference",
                },
                {
                  img: banner6,
                  title:
                    "Marching confidently towards a bright and boundless future",
                  // text: "Join Us in Making a Difference",
                },
              ].map((slide, idx) => (
                <Carousel.Item key={idx}>
                  <div className="carousel-overlay"></div>
                  <img
                    className="d-block w-100 carousel-image"
                    src={slide.img}
                    alt={`Slide ${idx + 1}`}
                  />
                  <Carousel.Caption>
                    <h1 className="carousel-title">{slide.title}</h1>
                    {/* <p className="carousel-text">{slide.text}</p> */}
                  </Carousel.Caption>
                </Carousel.Item>
              ))}
            </Carousel>

            {/* Custom Right-Side Indicators */}
            <div className="custom-indicators">
              {[0, 1, 2, 3, 4, 5].map((idx) => (
                <div
                  key={idx}
                  className={`indicator ${index === idx ? "active" : ""}`}
                  onClick={() => setIndex(idx)}
                />
              ))}
            </div>
          </div>
        </motion.div>

        <Container fluid className="overview-container">
          <Row className="align-items-center">
            {/* Image Section */}
            <Col lg={6} className="image-container">
              <Card className="image-card">
                <Card.Img src={susan} alt="Library" className="rounded-img" />
              </Card>
            </Col>

            {/* Text Content Section */}
            <Col lg={6} className="text-container">
              <div className="content-box">
                <h5
                  className="overview-title"
                  style={{ padding: "0 20px", textAlign: "justify" }}
                >
                  OVERVIEW
                </h5>

                <p
                  className="overview-text"
                  style={{ padding: "0 20px", textAlign: "justify" }}
                >
                  <strong>
                    Deepti Special School and Rehabilitation Centre{" "}
                  </strong>
                  has been a beacon of hope and transformation for children with
                  special needs and their families. True to the meaning of its
                  name—Deepti, or "light"—the institution shines as a source of
                  encouragement, care, and empowerment for those navigating the
                  challenges of raising differently-abled children. Deepti
                  provides free education and comprehensive rehabilitation
                  services to children with a range of special needs, with a
                  singular mission: to integrate them into the mainstream of
                  society with dignity and independence. Today, Deepti supports
                  over 220 children and their families, offering not just care,
                  but a community rooted in compassion, expertise, and
                  unwavering support.
                </p>
              </div>

              <div className="mission-box">
                <h5
                  className="mission-title"
                  style={{ padding: "0 20px", textAlign: "justify" }}
                >
                  OUR MISSION
                </h5>
                <p
                  className="mission-text"
                  style={{ padding: "0 20px", textAlign: "justify" }}
                >
                  Deepti Special School is dedicated to becoming a leading
                  center of excellence in special education by upholding the
                  highest standards of professional integrity, child-centric
                  approaches, and compassionate service. Our mission is to
                  empower individuals with special needs to lead independent,
                  dignified lives. We accomplish this through integrated medical
                  and therapeutic interventions, individualized educational
                  programs, practical vocational training, and the development
                  of robust social and physical support systems.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        {/* <Container className="py-5"> */}
        <div className="text-center mb-5 mt-3">
          <h1 className="empowering-child-quotes fw-bold mb-3">
            Whom we serve
          </h1>
          <p
            className="fs-5 text-secondary mx-auto"
            style={{ maxWidth: "700px", fontStyle: "italic" }}
          >
            Empowering Every Child to Reach Their Full Potential
          </p>
        </div>

        <section className="mt-5 px-3">
          <Carousel indicators={true} controls={true} interval={null}>
            {Array.from(
              { length: Math.ceil(conditions.length / 3) },
              (_, i) => (
                <Carousel.Item key={i}>
                  <div className="d-flex justify-content-center flex-wrap gap-4 px-4 py-3">
                    {conditions
                      .slice(i * 3, i * 3 + 3)
                      .map((condition, idx) => {
                        const globalIdx = i * 3 + idx;
                        const isExpanded = expandedCards[globalIdx] || false;
                        const maxLength = 100;
                        const isLongText = condition.text.length > maxLength;
                        const displayText = isExpanded
                          ? condition.text
                          : condition.text.slice(0, maxLength) +
                            (isLongText ? "..." : "");

                        return (
                          <div
                            key={globalIdx}
                            className="card shadow-sm text-center p-3"
                            style={{
                              flex: "0 0 30%",
                              maxWidth: "30%",
                              minWidth: "250px",
                            }}
                          >
                            <img
                              src={condition.image}
                              alt={condition.title}
                              className="img-fluid mb-2"
                              style={{
                                maxHeight: "150px",
                                objectFit: "cover",
                                width: "100%",
                              }}
                            />
                            <h6 className="fw-semibold">{condition.title}</h6>
                            <p className="text-secondary small mb-0">
                              {displayText}
                              {isLongText && (
                                <span
                                  onClick={() => toggleExpand(globalIdx)}
                                  style={{
                                    color: "#007bff",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                    marginLeft: "5px",
                                  }}
                                >
                                  {isExpanded ? "Read Less" : "Read More"}
                                </span>
                              )}
                            </p>
                          </div>
                        );
                      })}
                  </div>
                </Carousel.Item>
              )
            )}
          </Carousel>
        </section>

        <div className="gallery-container">
          <h2 className="gallery-title">OUR GALLERY</h2>

          <div className="gallery-img">
            {galleryMedia && galleryMedia.length > 0 ? (
              galleryMedia.map((media, index) => (
                <div key={index} className="gallery-image-container">
                  {media.type === "image" ? (
                    <img
                      src={media.src}
                      alt={`Gallery image ${index + 1}`}
                      className="gallery-image"
                    />
                  ) : (
                    <video src={media.src} controls className="gallery-video" />
                  )}
                </div>
              ))
            ) : (
              <div className="no-images-message">No gallery media found</div>
            )}
          </div>

          <div className="button-container">
            <button onClick={handleViewGallery} className="view-gallery-button">
              VIEW FULL GALLERY
            </button>
          </div>
        </div>

        <div className="text-center mt-5">
          <div className="styled-quote">
            <p className="quote-text">
              Our experienced educators and specialists work together to create
              personalized learning plans that address each child's unique needs
              and help them thrive academically and socially.
            </p>
          </div>
        </div>
        {/* </Container> */}
        <section className="management-section">
          <Container>
            <h2 className="management-heading text-center mb-5">
              The Visionaries
            </h2>
            <Row className="management-details justify-content-center">
              {managementTeam?.map((member, index) => (
                <Col
                  key={index}
                  md={4}
                  className="d-flex justify-content-center mb-4"
                >
                  <Card className="management-card">
                    <Card.Img
                      variant="top"
                      src={`https://api.deepticentre.com/${member.m_image}`}
                      className="card-image"
                      alt={member.m_name}
                    />
                    <Card.Body className="text-center">
                      <Card.Title>{member.m_name}</Card.Title>
                      <Card.Text>{member.m_position}</Card.Text>
                      <Card.Text className="text-dark">
                        {member.m_qualification}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <div className="testimonial-section text-center p-5">
          <h4 className="whats-parents-say fw-bold">What parents say</h4>
          <Carousel indicators={false} controls={false} interval={3000}>
            {testimonials.map((testimonial, index) => (
              <Carousel.Item key={index}>
                <div className="d-flex flex-column align-items-center">
                  <span className="display-4 whats-parents-say">❝</span>
                  <p
                    className="parents-say-testimonial-text text-muted px-5"
                    style={{ fontStyle: "italic" }}
                  >
                    {testimonial.text}
                  </p>

                  <span className="display-4 whats-parents-say">❞</span>
                  <p className="text-warning fw-bold">— {testimonial.author}</p>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
        <div className="our-project-section py-5">
          <h2 className="management-heading text-center mb-5">
            BUILDING THE DREAM PROJECT
          </h2>
          <Container>
            <Row className="align-items-center">
              <Col md={6}>
                <Image
                  src={building} // Replace with your actual image
                  alt="Project Visual"
                  fluid
                  rounded
                />
              </Col>
              <Col md={6}>
                <h3 className="mb-3 dream-title">
                  <em>Transforming Ideas into Reality</em>
                </h3>
                <p className="dream-text">
                  <em>
                    Currently operating across four rented spaces, Deepti is
                    building a new, centralized facility near St. Cyril's
                    College, Kilivayal, Adoor. This will enhance services and
                    improve support for children with special needs. Join us in
                    building their brighter future.
                  </em>
                </p>
                <p className="dream-text">
                  <em>
                    Deepti invites you to be a part of this noble project
                    through donations and sponsorship for the classrooms,
                    therapy rooms, therapy pool, play facilities, autism block,
                    and CP block.
                  </em>
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Home;
